import { ActionIcon } from '@mantine/core';
import Link from 'next/link';
import { FC, HTMLAttributeAnchorTarget, ReactNode } from 'react';

interface FooterLinkProps {
    link: string;
    target?: HTMLAttributeAnchorTarget;
    children: ReactNode;
}

export const FooterLink: FC<FooterLinkProps> = ({ link, target, children }) => (
    <ActionIcon
      component={Link}
      href={link}
      target={target ?? '_blank'}
      rel="noopener noreferrer"
      variant="subtle"
      color="gray"
      radius="xl"
      size={40}
    >
        { children }
    </ActionIcon>
);
